/**
 * Desktop Spacing Constants
 * Consistent spacing values for all desktop layouts
 */

export const DESKTOP_SPACING = {
  // Top margins from header
  PAGE_TOP: "80px",

  // Header spacing
  PAGE_HEADER_BOTTOM: "24px",

  // Container settings
  MAX_WIDTH: {
    XL: "xl", // For dashboard, upcoming games (wide layouts)
    LG: "lg", // For settings (medium layouts)
    MD: "md", // For create game, forms (narrow layouts)
  },

  // Content cards
  CARD: {
    PADDING: 3, // 24px
    BORDER_RADIUS: "8px",
    BORDER: "1px solid #E5E5E5",
    BACKGROUND: "white",
  },

  // Layout gaps
  SECTION_GAP: "24px", // Between major sections
  ELEMENT_GAP: 3, // 24px - Between related elements
  SMALL_GAP: 2, // 16px - Between small elements

  // Special layouts
  SPLIT_LAYOUT_GAP: "24px", // For split-screen layouts (upcoming games)
  SIDEBAR_WIDTH: "320px", // For dashboard sidebar

  // Page backgrounds
  BACKGROUND: {
    MAIN: "#f5f5f5", // Main desktop background
    CARD: "white", // Card backgrounds
  },
};

/**
 * Standard desktop layout styles
 */
export const DESKTOP_LAYOUTS = {
  // Standard page container
  pageContainer: (maxWidth = DESKTOP_SPACING.MAX_WIDTH.XL) => ({
    // mt: DESKTOP_SPACING.PAGE_TOP,
    maxWidth: maxWidth,
  }),

  // Page header
  pageHeader: {
    mb: DESKTOP_SPACING.PAGE_HEADER_BOTTOM,
  },

  // Content card
  contentCard: {
    backgroundColor: DESKTOP_SPACING.CARD.BACKGROUND,
    borderRadius: DESKTOP_SPACING.CARD.BORDER_RADIUS,
    p: DESKTOP_SPACING.CARD.PADDING,
    border: DESKTOP_SPACING.CARD.BORDER,
  },

  // Split layout (for upcoming games style)
  splitLayout: {
    display: "flex",
    gap: DESKTOP_SPACING.SPLIT_LAYOUT_GAP,
    height: "calc(100vh - 200px)",
    minHeight: "600px",
  },

  // Dashboard multi-column
  dashboardLayout: {
    display: "flex",
    gap: DESKTOP_SPACING.ELEMENT_GAP,
  },

  // Page background
  pageBackground: {
    backgroundColor: DESKTOP_SPACING.BACKGROUND.MAIN,
    minHeight: "auto",
    pt: 0,
    pb: 4,
  },
};
